// removed by extract-text-webpack-plugin
module.exports = {"section":"_1-yqE","featuredItemsListDesktop":"_1876m","buttonSection":"_1ZqrW"};